//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClassicItem from "@/components/ClassicItem.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CollectionKind",
  created() {
    this.id = this.$route.params.id;
    if (this.libraryData.collections.length === 0) {
      this.loadLibraryData();
    }
  },

  data() {
    return {
      lists: [],
      loading: false,
      page: 1,
      id: null,
    };
  },
  metaInfo() {
    return {
      title: "选集",
      titleTemplate: null,
    };
  },
  methods: {
    ...mapActions(["loadLibraryData"]),
  },
  computed: {
    ...mapGetters(["libraryData", "collectionKinds", "collections"]),
    collectionKind() {
      if (!this.id) {
        return null;
      }
      return this.collectionKinds.find(
        (kind) => kind.get("localId") == this.id
      );
    },
    currentCollections() {
      if (!this.id) {
        return [];
      }
      return this.collections
        .filter((c) => c.get("kindId") == this.id)
        .sort((a, b) => a.get("order") - b.get("order"));
    },
  },
  components: {
    ClassicItem,
  },
};



// WEBPACK FOOTER //
// ./src/pages/CollectionKind.vue